import { StoreState } from "@/redux/RootReducer";
import { GeneralStatisticsState } from "./reducer";

export const generalStatisticsSelectors = {
  getGeneralStatisticsState: (state: StoreState): GeneralStatisticsState =>
    state.statistics.statisticsGeneral,
};
